import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  centered: {
    margin: 'auto',
  },
}));
